import type { TFunction } from 'i18next'

/**
 * Adapter for react-i18next's overloaded TFunction → narrow string-returning function.
 * Safe: with plain string keys + primitive interpolation vars, i18next always returns string.
 */
export const toTFn = (t: TFunction) =>
  (key: string, vars?: Record<string, unknown>): string =>
    t(key, vars) as string
